/**
 * @author Ariel
 * @description 经销商管理页面配置
 * @createDate 2020/1/9
 * @updateDate 2020/3/11
 */
import React from "react";
import { WizTableForm } from "../../common";
import moment from "moment";
import { component_tool } from "../../../tool";
let { WizDataTable, WizButton } = component_tool

let componentName = 'dealerAppeal'

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const columns = (dataInfo) => {
  // let dictNew=[]
  // if(dataInfo.length){
  //   dataInfo.forEach(element => {
  //     let dictInfo = { code: element.id, codeName: element.brandName }
  //     dictNew.push(dictInfo);
  //   });
  // }
  return [
    {
      name: 'id',
      formItem: { type: 'hidden' }
    },
    {
      title: '品牌',
      name: 'brandName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '区域',
      name: 'areaName',
      tableItem: {},
      searchItem: {},
    },
    {
      title: '门店代码',
      name: 'dealerCode',
      tableItem: {},
      searchItem: {},
    },
    {
      title: '门店名称',
      name: 'dealerName',
      tableItem: {},
      searchItem: {},
    },
    {
      title: '发出者',
      name: 'sender',
      tableItem: {},
      searchItem: {},
    },
    {
      title: '发出者手机号',
      name: 'senderMobile',
      tableItem: {}
    },
    {
      title: '发出者邮箱',
      name: 'senderMail',
      tableItem: {}
    },
    {
      title: '发出日期',
      name: 'senderTime',
      tableItem: {}
    },
    {
      title: '发出日期',
      name: 'senderTime',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      }
      // searchItem: {
      //   type: 'date~',
      //   showTime: {format: 'HH:mm'},
      //   format: 'YYYY-MM-DD HH:mm'
      // },
    },
    {
      title: '车型',
      name: 'vehicleModelId',
      dict : dataInfo,
      // dict: [
      //   { code: 1, codeName: 'GL8 ES 653T 舒适型 23' },
      //   { code: 2, codeName: 'GL8 ES 653T 尊享型 23' },
      //   { code: 3, codeName: 'GL8 ES 653T 豪华型(谦和米) 23' },

      //   { code: 4, codeName: 'GL8 陆尊插混 智享版 25.5' },
      //   { code: 5, codeName: 'GL8 陆尊插混 尊享版 25.5' },
      //   { code: 6, codeName: 'GL8 陆尊插混 七座奢享版(玄武月白内饰) 25.5' },
      //   { code: 7, codeName: 'GL8 陆尊插混 七座奢享版(黛蓝月白内饰) 25.5' },
      //   { code: 8, codeName: 'GL8 陆尊插混 六座奢享版(黛蓝月白内饰) 25.5' },

      //   { code: 9, codeName: 'GL8 Avenir艾维亚 六座贤礼版(Sangria) 23' },

      //   { code: 10, codeName: 'GL8 652T 舒适型 24' },
      //   { code: 11, codeName: 'GL8 652T 智享型 24' },
      //   { code: 12, codeName: 'GL8 652T 豪华型(谦和米) 24' },
      //   { code: 13, codeName: 'GL8 652T 尊贵型(谦和米) 24' },
      //   { code: 14, codeName: 'GL8 652T 智慧尊贵型 24' },
      //   { code: 15, codeName: 'GL8 豪华型-专供版 24' },
      //   { code: 16, codeName: 'GL8 智享型-专供版 24' },

      //   { code: 17, codeName: '昂科威Plus 28T 豪华型 24' },
      //   { code: 18, codeName: '昂科威Plus 28T 尊享版(页岩黑) 24' },
      //   { code: 19, codeName: '昂科威Plus 28T 尊享版(丹霞红) 24' },
      //   { code: 20, codeName: '昂科威Plus 28T 四驱尊享版 24' },
      //   { code: 21, codeName: '昂科威Plus 艾维亚 24.5' },

      //   { code: 22, codeName: '世纪CENTURY 七座臻享款 23' },
      //   { code: 23, codeName: '世纪CENTURY 七座蕴世版(红黑内饰-赤霞红座椅) 23' },
      //   { code: 24, codeName: '世纪CENTURY 七座蕴世版(蓝白内饰-云峰白座椅) 23' },
      //   { code: 25, codeName: '世纪CENTURY 六座蕴世版(红黑内饰-赤霞红座椅) 23' },
      //   { code: 26, codeName: '世纪CENTURY 六座蕴世版(蓝白内饰-云峰白座椅) 23' },
      //   { code: 27, codeName: '世纪CENTURY 四座私享版(青白内饰-冷杉青座椅) 23' },
      //   { code: 28, codeName: '世纪CENTURY 四座私享版(青白内饰-云峰白座椅) 23' },
      //   { code: 29, codeName: '世纪CENTURY 四座私享版-关山飞雪双色车身(青白内饰-冷杉青座椅) 23' },
      //   { code: 30, codeName: '世纪CENTURY 四座私享版-关山飞雪双色车身(青白内饰-云峰白座椅) 23' }
      // ],
      searchItem: {
        type: 'select'
      },
      tableItem: {

      },
    },
    {
      title: '车架号',
      name: 'vehicleIdentifyNum',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '发票金额(元)',
      name: 'invoiceValue',
      tableItem: {}
    },
    {
      title: '发票日期',
      name: 'invoiceTime',
      tableItem:{
        render: (text, record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '发票日期',
      name: 'invoiceTime',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      }
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {}
    },
    {
      title: '邮箱',
      name: 'mail',
      tableItem: {}
    },
    {
      title: '是否置换',
      name: 'isDisplace',
      dataIndex: 'isDisplace',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '置换类型',
      name: 'displaceType',
      dataIndex: 'displaceType',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '本品置换' },
        { code: 2, codeName: '竞品置换' }
      ]
    },
    {
      title: '是否增购',
      name: 'isAdd',
      dataIndex: 'isAdd',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '增购类型',
      name: 'addType',
      dataIndex: 'addType',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '奔驰' },
        { code: 2, codeName: '宝马' },
        { code: 3, codeName: '奥迪' },
        { code: 4, codeName: '凯迪拉克' },
        { code: 5, codeName: '雪佛兰' },
        { code: 6, codeName: '别克' }
      ]
    },

    {
      title: '是否按揭',
      name: 'isMortgage',
      dataIndex: 'isMortgage',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '按揭金额(元)',
      name: 'mortgageValue',
      tableItem: {}
    },


    {
      title: '是否质损车',
      name: 'isDamaged',
      dataIndex: 'isDamaged',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '是否试乘试驾车',
      name: 'isTestDrive',
      dataIndex: 'isTestDrive',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '是否集团客户',
      name: 'isBloc',
      dataIndex: 'isBloc',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '是否享受政府补贴',
      name: 'isSubsidy',
      dataIndex: 'isSubsidy',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '补贴金额(元)',
      name: 'subsidyValue',
      dataIndex: 'subsidyValue',
      tableItem: {},
    },
    {
      title: '补贴申领方式',
      name: 'subsidyWay',
      dataIndex: 'subsidyWay',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '个人' },
        { code: 2, codeName: '经销商代办' }
      ]
    },
    {
      title: '是否VIP购车',
      name: 'isVip',
      dataIndex: 'isVip',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '是否高库龄',
      name: 'isAging',
      dataIndex: 'isAging',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '是否可再次提交',
      name: 'isAllowSubmit',
      dataIndex: 'isAllowSubmit',
      tableItem: {},
      searchItem: {type: 'select'},
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ]
    },
    {
      title: '第几次提交',
      name: 'submitNum',
      dataIndex: 'submitNum',
      tableItem: {},
    },

  ]
};

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(e),
        searchBarProps: {
          // cols: {
          //   xs: 24,
          //   md: 12,
          //   xl: 12
          // },
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['invoiceTime'] && value['invoiceTime'].length === 2) {
              value['invoiceTimeStart'] = moment(value['invoiceTime'][0]).format("YYYY-MM-DD 00:00:00")
              value['invoiceTimeEnd'] = moment(value['invoiceTime'][1]).format("YYYY-MM-DD 23:59:59")
            }
            if (value['senderTime'] && value['senderTime'].length === 2) {
              value['senderTimeStart'] = moment(value['senderTime'][0]).format("YYYY-MM-DD 00:00:00")
              value['senderTimeEnd'] = moment(value['senderTime'][1]).format("YYYY-MM-DD 23:59:59")
            }
            delete value['invoiceTime']
            delete value['senderTime']
            return value
          },
          buttonSort: [ 'export','import'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'import',
              custom: true,
              params: { icon: 'import', children: '导入', type: 'import'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/dealerAppeal/vinImport',
                }
              }
            }
          ]
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "Modal",
              children: "Bla bla123 .."
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
        //  selectType: "checkbox",
          isScroll: true,
          bordered: true,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look'],
        rowOperateProps: {
          width: 120,
          fixed: 'right',
        },
        rowOperateView: [
          {
            key: 'look',
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/org/dealerAppeal/lookDealerAppeal'
              }
            }
          }
        ],
        commonOperate: {
         // delete: true
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
